import * as React from "react";
import type { SVGProps } from "react";
const SvgMapPin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21 10h1zm-9 13-.555.832a1 1 0 0 0 1.11 0zM3 10H2zm9-9v1zm8 9c0 3.098-2.016 6.104-4.226 8.437a29.4 29.4 0 0 1-3.973 3.48l-.27.192-.067.046-.016.01-.003.003L12 23l.555.832h.001l.002-.002.007-.005.023-.015.082-.057q.109-.074.302-.214a31.433 31.433 0 0 0 4.254-3.727C19.516 17.397 22 13.903 22 10zm-8 13 .555-.832-.003-.002-.016-.01-.068-.047-.27-.191a29.419 29.419 0 0 1-3.973-3.48C6.016 16.103 4 13.097 4 10H2c0 3.902 2.484 7.396 4.774 9.813a31.4 31.4 0 0 0 4.254 3.726 19 19 0 0 0 .384.27l.023.016.007.005.002.001c.001 0 .001.001.556-.831M4 10a8 8 0 0 1 2.343-5.657L4.93 2.93A10 10 0 0 0 2 10zm2.343-5.657A8 8 0 0 1 12 2V0a10 10 0 0 0-7.071 2.929zM12 2a8 8 0 0 1 5.657 2.343L19.07 2.93A10 10 0 0 0 12 0zm5.657 2.343A8 8 0 0 1 20 10h2a10 10 0 0 0-2.929-7.071zM14 10a2 2 0 0 1-2 2v2a4 4 0 0 0 4-4zm-2 2a2 2 0 0 1-2-2H8a4 4 0 0 0 4 4zm-2-2a2 2 0 0 1 2-2V6a4 4 0 0 0-4 4zm2-2a2 2 0 0 1 2 2h2a4 4 0 0 0-4-4z"
    />
  </svg>
);
export default SvgMapPin;
